import { RoamIconChromeLoading } from '@/components/icons/roamIconChrome';
import { cn } from '@/lib/utils';

/**
 * A full-page wait, laid out like the phone menu: one line up top, balloons
 * in the open space. A spinner inside a button stays a spinner.
 */
export function RoamLoading({ label, className }: { label: string; className?: string }) {
  return (
    <div
      role="status"
      aria-live="polite"
      className={cn(
        'relative flex min-h-dvh flex-col items-center overflow-hidden bg-[#f7f3ef] px-6 pt-[18vh]',
        className,
      )}
    >
      <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
        <img
          src="/assets/logos/Cloud_only.png"
          alt=""
          className="absolute bottom-[34%] left-[-1.5rem] w-28 opacity-80"
        />
        <img
          src="/assets/logos/Balloon_Only.png"
          alt=""
          className="animate-float absolute bottom-[42%] right-[-1.25rem] w-24"
        />
        <img
          src="/assets/logos/Balloon_with_clouds.png"
          alt=""
          className="absolute bottom-[-1rem] left-[-2rem] w-[115%]"
        />
      </div>
      <p className="relative z-10 flex items-center gap-2 text-base font-semibold text-[#3F3835]">
        <RoamIconChromeLoading className="h-4 w-4" />
        {label}
      </p>
    </div>
  );
}
